const pageQuery = {
  state: {
    listPagePars: ''
  },

  mutations: {
    SAVE_LIST_PAGE_PARS: (state, { path, pars }) => {
      const map = new Map()
      map.set(path, pars)
      state.listPagePars = map
    }
  },

  actions: {
    saveListPagePars: ({ commit }, { path, pars }) => {
      commit('SAVE_LIST_PAGE_PARS', { path, pars })
    }
  }
}

export default pageQuery
